import React, { useState } from 'react'
import "./LoginContainer.css"
import { toast } from 'react-toastify';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loginMethod } from '../../hooks/auth';
import CustomButton from "../CustomButton/CustomButton"
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import icons for show/hide
import CustomInput from '../CustomInput/CustomInput';
import { apiUrl } from '../../constants/apiUrl';

function LoginContainer() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // State to toggle visibility
  const [formData, setFormData] = useState({
    phone: '',
    password: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData?.phone || !formData?.password) {
      toast.error("Please fill all fields", { position: "bottom-right", autoClose: 3000 });
    } else {


      setLoading(true);
    try {
      const response = await axios.post(`${apiUrl}/admin/auth/login`, {
        phone:formData?.phone,
        password:formData?.password
      });

      dispatch(loginMethod(response.data.data))
      if(response.data.data.user.role=="Student"){
navigate("/dashboard/Dashboard")
      }else if(response.data.data.user.role=="Super Admin"){

navigate("/dashboard/Dashboard")
      }else{
        navigate("/dashboard/Dashboard")
      }
      
    } catch (error) {
      if(Object.values(error.response.data.errors)[0][0]=="The selected Identity Number is invalid."){
        toast.error("الرقم التعريفي غير صحيحة",{ position: "bottom-right", autoClose: 3000 })

      }else if(Object.values(error.response.data.errors)[0][0]=="Wrong Password"){

        toast.error("كلمة المرور غير صحيحة",{ position: "bottom-right", autoClose: 3000 })
      }else{
        toast.error(Object.values(error.response.data.errors)[0][0],{ position: "bottom-right", autoClose: 3000 })

      }
    } finally {
      setLoading(false);
    }
    }
  };
  return (
    <div className='login_container'>
      <div className='form_container'>
        <div className="card">
          <div className='logo_container_test'>{currentLocal.home.welcome}</div>
          <div className={"subtitle"}>{currentLocal.home.subtitle}</div>

          <form onSubmit={handleSubmit}>
            <div className={"inputGroup"}>
              <label>{currentLocal.home.phone}</label>


              <CustomInput

                type={"text"}
                name={"phone"}
                placeholder={currentLocal.home.phone}
                handleChange={handleChange}
              />
            </div>

            <div className={"inputGroup"}>
              <label>{currentLocal.home.passwordPlaceholder}</label>
              <CustomInput

                type={showPassword ? "text" : "password"}
                name={"password"}
                placeholder={"••••••••"}
                handleChange={handleChange}
              />
              {/* <input
                type={showPassword?"text":"password"}
                name="password"
                className={"input"}
                placeholder="••••••••"
                onChange={handleChange}
                required
              /> */}
              <span
                className="eye-icon"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: currentLocal.language === "English" && "10px",
                  left: currentLocal.language === "العربيه" && "10px",

                  top: "65%",
                  transform: "translateY(-50%)",
                  cursor: "pointer"
                }}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
            <div>
              <CustomButton
                disable={loading}
                text={currentLocal.home.login}
                type={"submit"}

              />
            </div>
            {/* <button type="submit" className={"button"}>{currentLocal.home.login}</button> */}
          </form>

          {/* <div className={"footerLinks"}>
            <Link to="/forgot-password" className={{ textDecoration: 'none', color: '#3498db' }}>{currentLocal.home.forgetPassword}</Link>
          </div> */}
        </div>
      </div>
    </div>
  )
}

export default LoginContainer
